/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RenditionsControllerFindAllQueryResponse, RenditionsControllerFindAllPathParams, RenditionsControllerFindAllQueryParams, RenditionsControllerFindAll401, RenditionsControllerFindAll403 } from "../../models/documentRenditionsController/RenditionsControllerFindAll";

function getRenditionsControllerFindAllUrl(documentId: RenditionsControllerFindAllPathParams["documentId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions` as const }  
  return res
}

/**
 * @description Returns renditions with JSON:API pagination, sorting, and filtering
 * @summary List renditions for a document
 * {@link /api/v1/documents/:documentId/renditions}
 */
export async function renditionsControllerFindAll(documentId: RenditionsControllerFindAllPathParams["documentId"], params?: RenditionsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RenditionsControllerFindAllQueryResponse, ResponseErrorConfig<RenditionsControllerFindAll401 | RenditionsControllerFindAll403>, unknown>({ method : "GET", url : getRenditionsControllerFindAllUrl(documentId).url.toString(), params, ... requestConfig })  
  return res.data
}